import { useTranslation } from 'react-i18next'
import styles from './DateFilter.module.scss'

const DateFilter = ({ value, onChange, label }) => {
  const { t } = useTranslation('common')
  const finalLabel = label !== undefined ? label : t('reports.date_cutoff')
  return (
    <div className={styles.wrap}>
      <label className={`unv-label ${styles.label}`}>{finalLabel}</label>
      <input
        type="date"
        className={`unv-input ${styles.input}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default DateFilter
